<!-- View All -->
<ng-template #viewAll
  let-mobile="mobile">
  <yc-button
    [class.me-3]="!mobile"
    class="mb-2"
    [link]="true"
    [linkPath]="['/apply/applications']">
    <yc-i18n
      [key]="isNomination ?
        'APPLY:textViewAllMyNominations' :
        'APPLY:textViewAllMyApplications'"
      [defaultValue]="isNomination ?
        'View all my nominations' :
        'View all my applications'">
    </yc-i18n>
  </yc-button>
</ng-template>

<!-- Start New -->
<ng-template #startNew
  let-mobile="mobile">
  <yc-button *ngIf="hasDraftApplication && !program.eligibilityForm && !programIsArchived"
    [primary]="true"
    [class.pb-5]="mobile"
    [translatedText]="continueText"
    (onClick)="onContinueToApp()">
  </yc-button>
</ng-template>

<!-- Continue -->
<ng-template #continue
  let-mobile="mobile">
  <yc-button *ngIf="(!hasDraftApplication || program.eligibilityForm) && !programIsArchived"
    [primary]="true"
    [fontAwesomeIcon]="'pencil'"
    [translatedText]="continueText"
    [class.pb-5]="mobile"
    (onClick)="onContinueToApp()">
  </yc-button>
</ng-template>

<div *ngIf="loaded"
  class="row">
  <div *ngIf="program.imageUrl"
    class="background-container" 
    [ngStyle]="{ 'background-image': 'url('+  (program.imageUrl | gcAddStaticResourceSAS) + ')' }">
    <div class="background-container-grad">
      <div *ngIf="!onCopyStep" 
        class="apply-container program-details">
        <div class="d-flex flex-column break-word">
          <div class="d-flex align-items-center">
            <!-- Client Image -->
            <div class="apply-client-logo-container">
              <img class="apply-client-logo" 
                src="{{ (program.logoUrl || program.clientLogoUrl) | gcAddStaticResourceSAS }}"
                [alt]="'PROGRAM:textProgramLogo' | ycI18n: 'Program logo'"/>
            </div>

            <div>
              <!-- Program Name -->
              <h2 class="mb-0 program-name">
                {{ programName }}
              </h2>

              <!-- Program Guidelines -->
              <div *ngIf="!!program.grantProgramGuidelines" class="mb-2">
                <yc-button
                  [borderOnHover]="false"
                  [link]="true"
                  [langKey]="'PROGRAM:viewGuidelines'"
                  [defaultText]="'View Guidelines'"
                  (onClick)="viewGuidelines()">
                </yc-button>
              </div>

              <!-- Program Dates -->
              <div>
                {{ programAcceptanceText }}
                <br/>
                {{ invitationNotFoundText || alreadyAppliedText || invitationRequiredText || programDatesText }}
              </div>
            </div>
          </div>

          <!-- Program Description-->
          <div class="m-3 description-container">
            <yc-rich-text-display
              [html]="translationMap.description">
            </yc-rich-text-display>
          </div>
        </div>

        <!-- Existing Applications  -->
        <ng-container *ngIf="hasDraftApplication">
          <hr>
          <div class="mb-3">
            <yc-i18n *ngIf="repository.currentSet?.length > 1"
              [key]="isNomination ?
                'APPLY:textYouHaveNominationsProgramNotSubmittedDynamic' :
                'APPLY:textYouHaveApplicationsProgramNotSubmittedDynamic2'"
              [context]="{
                numberOfApps: repository.currentSet?.length
              }"
              [defaultValue]="isNomination ?
                'You have __numberOfApps__ nominations that have not been submitted. Select one to edit a draft, view all my nominations, or start a new nomination.' :
                'You have __numberOfApps__ applications that have not been submitted. Select one to edit a draft, view all my applications, or start a new application.'">
            </yc-i18n>
            <yc-i18n *ngIf="repository.currentSet?.length === 1"
              [key]="isNomination ?
                'APPLY:textYouHave1NominationProgramNotSubmittedDynamic' :
                'APPLY:textYouHave`ApplicationProgramNotSubmittedDynamic2'"
              [defaultValue]="isNomination ?
                'You have 1 nomination that has not been submitted. Click edit, view all my nominations, or start a new nomination.' :
                'You have 1 application that has not been submitted. Click edit, view all my applications, or start a new application.'">
            </yc-i18n>
          </div>

          <div class="mb-4">
            <yc-scrolling-list *ngIf="repository"
              [hasBorder]="true"
              [repository]="repository"
              [maxHeight]="200">
              <ng-container *ycScrollingListItem="let application;">
                <div>
                  <gc-application-slat
                    [application]="application"
                    [simpleSlat]="true"
                    [canEdit]="programValid"
                    (onSelectApplication)="selectDraftApp(application)">
                  </gc-application-slat>
                </div>
              </ng-container>
            </yc-scrolling-list>
          </div>
        </ng-container>

        <ng-container *ngIf="programIsArchived">
          <p class="text-danger">{{programIsArchivedText}}</p>
        </ng-container>

        <!-- Non Mobile-->
        <div class="d-none d-md-flex justify-content-end align-items-center mb-2">
          <!-- View All -->
          <ng-template *ngTemplateOutlet="viewAll"></ng-template>

          <ng-container *ngIf="programValid">
            <!-- Start New -->
            <ng-template 
              *ngTemplateOutlet="startNew">
            </ng-template>
            <!-- Continue -->
            <ng-template 
              *ngTemplateOutlet="continue">
            </ng-template>
          </ng-container>
        </div>


        <!-- Mobile-->
        <div class="d-flex d-md-none justify-content-center align-items-center mb-2">
          <!-- View All -->
          <ng-template 
            *ngTemplateOutlet="viewAll; context: { mobile: true }">
          </ng-template>

          <ng-container *ngIf="programValid">
            <!-- Start New -->
            <ng-template 
              *ngTemplateOutlet="startNew; context: { mobile: true }">
            </ng-template>

            <!-- Continue -->
            <ng-template 
              *ngTemplateOutlet="continue; context: { mobile: true }">
            </ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

